import { render, staticRenderFns } from "./use-cases.vue?vue&type=template&id=9cbb81fe&"
import script from "./use-cases.vue?vue&type=script&lang=js&"
export * from "./use-cases.vue?vue&type=script&lang=js&"
import style0 from "./use-cases.vue?vue&type=style&index=0&id=9cbb81fe&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports